import { useRef } from "react";
import useReveal from "@/hooks/useReveal";

export default function Terrasse() {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section
      ref={ref}
      data-testid="terrasse-section"
      className="relative overflow-hidden"
    >
      <div className="relative grid lg:grid-cols-2 min-h-[480px]">
        <div className="relative min-h-[320px] sm:min-h-[420px]">
          <img
            src="/images/site/eingang.webp"
            alt="Eingang und Terrasse von Niko's Grill"
            className="absolute inset-0 w-full h-full object-cover object-[center_60%]"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[var(--niko-dark)]/40 to-transparent" />
        </div>
        <div className="relative bg-[var(--niko-blue)] text-white py-20 md:py-28 px-8 lg:px-20 flex items-center">
          <div>
            <p className="reveal divider-leaf max-w-[200px] mb-7" style={{ color: "var(--niko-gold)" }}>
              Sommer
            </p>
            <h2
              className="reveal reveal-delay-1 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
              data-testid="terrasse-headline"
            >
              <span className="text-[var(--niko-gold)]">☀</span> Unsere{" "}
              <span className="italic">Sommer-Terrasse</span>
            </h2>
            <p className="reveal reveal-delay-2 mt-6 text-white/85 text-base md:text-lg leading-relaxed max-w-md">
              Wenn die Sonne scheint, genießen Sie Ihr griechisches Essen im
              Freien. Unsere Terrasse lädt zum Verweilen ein — kommen Sie einfach
              vorbei oder rufen Sie uns kurz an.
            </p>
            <a
              href="tel:+492327995454"
              data-testid="terrasse-cta"
              className="reveal reveal-delay-3 mt-9 inline-flex items-center gap-3 px-7 py-4 rounded-full bg-[var(--niko-gold)] text-[var(--niko-dark)] text-sm font-semibold tracking-[0.18em] uppercase hover:bg-[var(--niko-gold-soft)] transition-colors"
            >
              Jetzt anrufen <span>→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
